var render = function render(_c,_vm){return _c('section',{class:[ _vm.data.class, _vm.data.staticClass, 'box-shadow' ],style:([ _vm.data.style, _vm.data.staticStyle ])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }